export default __webpack_public_path__ + "locales/pl/Ldap.json?hash=dc3f530324efeb7aba2a579b1b565657";